import cx from 'classnames';
import * as React from 'react';

import Legend from 'components/Legend';

import './styles/Fieldset.scss';

// TODO
// * Rename/rework `size` prop

export type Props = {
  children: React.ReactNode;
  className?: string;
  legend?: string;
  size?: 'small';
};

export default class Fieldset extends React.Component<Props> {
  render() {
    const { children, className, legend, size } = this.props;

    // renders `div` instead of `fieldset` to not require `form` wrapper
    // https://bugs.chromium.org/p/chromium/issues/detail?id=570095#c22
    return (
      <div className={cx('Fieldset', size && `Fieldset--${size}`, className)}>
        {legend && <Legend>{legend}</Legend>}
        {children}
      </div>
    );
  }
}
